import React from "react";
import { Check } from "lucide-react";

export default function VerticalStepper({ steps, currentStep }) {
  return (
    <div className="flex flex-col gap-6 relative">
      {/* Background Line */}
      <div className="absolute right-[19px] top-4 bottom-4 w-0.5 bg-slate-100 z-0"></div>

      {steps.map((step, index) => {
        const isCompleted = step.id < currentStep;
        const isActive = step.id === currentStep;
        const isUpcoming = step.id > currentStep;

        return (
          <div key={step.id} className="relative z-10 flex items-center gap-4 group">
            {/* Step Circle */}
            <div
              className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm transition-all duration-300 shrink-0
                ${isCompleted
                  ? "bg-gray-300 text-black shadow-md shadow-gray-300/50"
                  : isActive
                    ? "bg-[#2b2b2b] text-white shadow-lg shadow-neutral-900/20 scale-110"
                    : "bg-white border-2 border-slate-200 text-slate-400"
                }`}
            >
              {isCompleted ? <Check size={18} /> : <span>{step.id}</span>}
            </div>

            {/* Step Label */}
            <div className="flex flex-col">
              <span
                className={`text-sm font-bold transition-colors duration-300 ${
                  isActive ? "text-[#2b2b2b]" : isCompleted ? "text-slate-700" : "text-slate-400"
                }`}
              >
                {step.title}
              </span>
              {isActive && (
                <span className="text-[10px] text-slate-500 font-semibold mt-0.5 animate-pulse">
                  در حال انجام...
                </span>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
